import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { newVmDbUpdateTagsCdb, VmDbUpdateTagsCdbProps } from "./VmDbUpdateTagsCdb";

export interface VmDbEditTagsCdbProps extends OperationActionProps {
  databaseId: string | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultTags?: { name: string; value: any; }[];
}

const VmDbEditTagsCdb = (
  { targetId, location, databaseId, defaultTags, onExecute, onCancel }: VmDbEditTagsCdbProps,
): JSX.Element => {
  const { trigger: triggerUpdateTagsCdb } = useOperation<VmDbUpdateTagsCdbProps>(newVmDbUpdateTagsCdb);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tags: { name: string; value: any; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateTagsCdb({
          databaseId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newVmDbEditTagsCdb = (
  props: VmDbEditTagsCdbProps,
): JSX.Element => (<VmDbEditTagsCdb {...props} />);
